module.exports = __webpack_public_path__ + "img/bold.2d875ea4.svg";